import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { notification, Button, Descriptions, Input, Radio, Select } from 'antd';
import { COMPANY_TYPE, SUBNAME_TYPE, CE_TYPE } from 'constant';
import { text_companyNm } from 'lib/textChang';

@inject('centerInfoStore')
@observer
class CenterDetail extends Component {
  state = {
    saveData: {
      ceCd: '',
      ceNm: '',
      ceUseYn: 'Y',
      ceType: CE_TYPE.BRANCH,
      ceBranchCd: '',
      ceBranchNm: '',
      ceSubName: '',
    }
  };

  UNSAFE_componentWillMount() {
    if (this.props.sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ceType: CE_TYPE.CENTER
      }});
    }
  }

  onChangValue = (dataVal, dataNm) => {
    if (dataNm === 'ceCd') {
      this.props.centerInfoStore.onChangValue('checkCeCd', false);
    }

    if (dataNm === 'ceType' && dataVal === CE_TYPE.BRANCH) {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ceType: dataVal,
          ceBranchCd: '',
          ceBranchNm: '',
          ceSubName: '',
      }});
      return;
    }
    
    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  setData = (mode) => {
    this.props.centerInfoStore.onViewMode(mode);
    const { sessionLoginInfo } = this.props;
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          ceCd: '',
          ceNm: '',
          ceUseYn: 'Y',
          ceType: (sessionLoginInfo.cGbn === COMPANY_TYPE.KNP)
            ? CE_TYPE.BRANCH
            : CE_TYPE.CENTER
        }
      });
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.centerInfoStore.detailData
      }});
    }
  };

  onSave = () => {
    if (this.state.saveData.ceCd === '') {
      notification.warning({placement: 'bottomLeft', message: `코드를 입력하세요.`, duration: 2});
      return false;
    }

    if (this.props.sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) {
      if(this.state.saveData.ceBranchCd === '') {
        notification.warning({placement: 'bottomLeft', message: `${text_companyNm()}를 선택해주세요.`, duration: 2});
        return false;
      }

      if(this.state.saveData.ceSubName === '') {
        notification.warning({placement: 'bottomLeft', message: `지사를 선택해주세요.`, duration: 2});
        return false;
      }
    }
    
    if (this.state.saveData.ceNm === '') {
      notification.warning({placement: 'bottomLeft', message: `센터명를 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.props.centerInfoStore.viewMode === 'add') {
      if (this.props.centerInfoStore.valCondition.checkCeCd === false) {
        notification.warning({placement: 'bottomLeft', message: `코드 중복체크를 해주세요.`, duration: 2});
        return false;
      }
      this.props.centerInfoStore.addCenterInfo(this.state.saveData);
    } else if (this.props.centerInfoStore.viewMode === 'mod') {
      this.props.centerInfoStore.modCenterInfo(this.state.saveData);
    }
  };

  render() {
    const { viewMode, valCondition, detailData, disCenterCheck } = this.props.centerInfoStore;
    const { saveData } = this.state;
    const { sessionLoginInfo } = this.props;
    return (
      <Fragment>
        <div className="button-group">
          <h2>정보
            {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
            {viewMode === 'add' && <Fragment> 추가</Fragment>}
            {viewMode === 'mod' && <Fragment> 수정</Fragment>}
          </h2>
          <div className="button-right">
            {viewMode === 'detail'
            ? <ul>
                <li><Button type="primary" onClick={()=>this.setData('list')}>목록</Button></li>
                <li><Button type="primary" onClick={()=>this.setData('mod')}>수정</Button></li>
              </ul>
            : <ul>
                <li><Button type="primary" onClick={()=>this.onSave()}>저장</Button></li>
                <li><Button type="primary" onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}>취소</Button></li>
              </ul>
            }
          </div>
        </div>

        <div className="table_th_W">
          <Descriptions bordered>
            {(sessionLoginInfo.cGbn === COMPANY_TYPE.KNP) &&
              <Descriptions.Item label="구분 *" span={1}>
                {text_companyNm()}
              </Descriptions.Item> 
            }
            {(sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) &&
            <Fragment>
              <Descriptions.Item label={text_companyNm() + " *"} span={1}>
                <CenterOptionList
                  onlyBranchCd={true}
                  branchCdDisabled={viewMode === 'detail'}
                  ceBranchCdValue={viewMode === 'detail'? detailData?.ceBranchCd : saveData?.ceBranchCd}
                  eBranchCdChange={(value)=>{
                    this.setState({
                      saveData: {
                        ...saveData,
                        ceBranchCd: value
                      }
                    });
                  }}
                />
                </Descriptions.Item> 
                <Descriptions.Item label={"지사 *"} span={1}>
                <Select
                  style={{ width: 150, marginRight: '20px' }}
                  value={viewMode === 'detail'? detailData?.ceSubName : saveData?.ceSubName}
                  onChange={(value)=>{
                    this.onChangValue(value, 'ceSubName');
                  }}
                  disabled={viewMode === 'detail'}
                >
                  {SUBNAME_TYPE.map(item=><Select.Option key={item}>{item}</Select.Option>)}
                </Select>
              </Descriptions.Item>
            </Fragment>
            }
            <Descriptions.Item label="사용유무 *" span={(sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) ? 1 : 2}>
              {viewMode === 'detail'
              ? ((detailData !== null && detailData.ceUseYn !== undefined && detailData.ceUseYn !== null) && 
                detailData.ceUseYn === 'Y' ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>)
              : <Radio.Group
                  onChange={(e)=>this.onChangValue(e.target.value, 'ceUseYn')}
                  value={(saveData !== null && saveData.ceUseYn !== undefined && saveData.ceUseYn !== null) ? saveData.ceUseYn : 'N'}
                >
                  <Radio value={"Y"}>사용</Radio>
                  <Radio value={"N"}>미사용</Radio>
                </Radio.Group>
              }
            </Descriptions.Item>

            <Descriptions.Item 
              label={(sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) ? "센터 *" : text_companyNm() + "*"} 
              span={1}
            >
              {(viewMode === 'detail')
              ? (detailData?.ceNm || '')
              : <Input
                  value={saveData?.ceNm}
                  onChange={(e)=>this.onChangValue(e.target.value, 'ceNm')}
                />
              }
            </Descriptions.Item>
            <Descriptions.Item 
              label={(sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) ? "센터코드 *" : text_companyNm() + "코드 *"}  
              span={2}
            >
              {(viewMode === 'detail' || viewMode === 'mod')
              ? (detailData?.ceCd || '')
              : <Fragment>
                  <Input
                    style={{ width: '40%' }}
                    value={saveData?.ceCd}
                    onChange={(e)=>this.onChangValue(e.target.value, 'ceCd')}
                  />
                  {valCondition.checkCeCd === false &&
                    <Button
                      type="primary"
                      onClick={()=>{
                        saveData?.ceCd === '' 
                        ? notification.warning({placement: 'bottomLeft', message: `체크할 값을 입력하세요.`, duration: 2})
                        : disCenterCheck(saveData?.ceCd);
                      }}
                    >중복체크</Button>
                  }
                </Fragment>
              }
            </Descriptions.Item>

          </Descriptions>
        </div>
      </Fragment>
    );
    
  }
}

export default withRouter(CenterDetail);
